import React from 'react';
import { Button, message, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import {
  UPDATE_PARTNER_BANK,
  CREATE_PARTNER_BANK,
} from '~pages/dashboard/referral/partner-account/queries';

function AccountBankEditor({
  partnerId,
  cardId,
  bankName,
  beneficiaryName,
  card,
  onClose,
  form: { getFieldDecorator, validateFields },
}) {
  const { t } = useTranslation();

  const [updatePartnerBank, { loading: updatePartnerBankLoading }] = useMutation(
    UPDATE_PARTNER_BANK,
    {
      onError: e => {
        message.error(e.message);
      },
    },
  );

  const [createPartnerBank, { loading: createPartnerBankLoading }] = useMutation(
    CREATE_PARTNER_BANK,
    {
      onError: e => {
        message.error(e.message);
      },
    },
  );
  // const [accountEnable, setAccountEnable] = useState({bankName,beneficiaryName,account});

  const handleSubmit = () => {
    validateFields(async (err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
      }
      if (cardId) {
        const response = await updatePartnerBank({
          variables: {
            input: {
              id: cardId,
              bankName: values.bankName || null,
              beneficiaryName: values.beneficiaryName || null,
              card: values.card || null,
            },
          },
        });
        if (response?.data?.updatePartnerBank) {
          message.success(
            t('cms.referral.partner.detail.editor.action.partner_status.toast.success'),
          );
          onClose();
        }
      } else {
        const response = await createPartnerBank({
          variables: {
            input: {
              partnerId,
              bankName: values.bankName,
              beneficiaryName: values.beneficiaryName,
              card: values.card,
            },
          },
        });
        if (response?.data?.createPartnerBank) {
          message.success(
            t('cms.referral.partner.detail.editor.action.partner_status.toast.success'),
          );
          onClose();
        }
      }
    });
  };

  return (
    <>
      <div className="partner-register-city-editor__body" style={{ marginTop: '8px' }}>
        <section className="partner-register-city-editor__section">
          <main className="partner-register-city-editor__main">
            <Form layout={'vertical'}>
              <Form.Item label="Partner Bank Name">
                {getFieldDecorator('bankName', { initialValue: bankName })(
                  <Input placeholder="Partner Bank Name" />,
                )}
              </Form.Item>
              <Form.Item label="Partner Beneficiary Name">
                {getFieldDecorator('beneficiaryName', { initialValue: beneficiaryName })(
                  <Input placeholder="Partner Beneficiary Name" />,
                )}
              </Form.Item>
              <Form.Item label="Partner Bank Account NO.">
                {getFieldDecorator('card', { initialValue: card })(
                  <Input placeholder="Partner Bank Account NO." />,
                )}
              </Form.Item>
            </Form>
          </main>
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          className="partner-register-city-editor__save-button"
          loading={updatePartnerBankLoading || createPartnerBankLoading}
          onClick={handleSubmit}
        >
          {t('cms.referral.partner.detail.editor.btn.save')}
        </Button>
      </div>
    </>
  );
}

export default Form.create({ name: 'bank' })(AccountBankEditor);
